export const aboutTimelineItems = [
    {
        year: "ca. 1910",
        title: "Ein Haus mit Geschichte",
        text: "Im Zentrum von Hooksiel entstand das Wohn- und Geschäftshaus, in dem Familie Johann Bornefeld mit Schneiderei und Textilgeschäft lebte und arbeitete.",
    },
    {
        year: "1950er",
        title: "Von Hosenknopf bis Gummiband",
        text: "Später befand sich hier ein Haushaltswarengeschäft, in dem man fast alles bekam. Der Eigentümer wurde liebevoll „Ernst Gummiband“ genannt.",
    },
    {
        year: "1980er",
        title: "Mode, Geschenke & Klönschnack",
        text: "Aus dem Haushaltswarengeschäft wurde ein Textil- und Geschenkartikelgeschäft. Besonders die Mode und die persönliche Beratung standen im Mittelpunkt.",
    },
    {
        year: "1996",
        title: "Souvenirs, Geschenke & Tee",
        text: "Das Sortiment veränderte sich: Souvenirs, Geschenkartikel und ein umfangreiches friesisches Teesortiment wurden wichtiger.",
    },
    {
        year: "2019",
        title: "Frischer Wind durch Claudia Don",
        text: "Claudia Don übernahm das Hooksieler Lädchen und brachte mit „Mode & Mee(h)r“ ihre Leidenschaft für sportlich-schicke Mode ein.",
    },
];